/**
 * FE-safe static projections — no draft runtime / no node:fs pull into Vite bundle.
 */
import type {
  BuilderDraftSuggestionViewV1,
  TodayAiAttentionCardV1,
  WorkbenchControlledLaneViewV1,
} from './surfaceProjectionsV1';

export function feSafeTodayAiAttentionCardV1(): TodayAiAttentionCardV1 {
  return {
    whyAttention:
      'PRODUCE_TO_OUTPUT STANDARD draft may benefit from a reversible AI naming suggestion on the transformation task',
    whatObserved: 'Draft task "Execute authorized transformation" on PRODUCE_TO_OUTPUT STANDARD',
    whatProposed: 'AI draft suggestion: rename task task_run_transformation',
    riskAuthorityState: 'LOW / ALLOW',
    approvalRequirement: 'satisfied',
    executionState: 'EXECUTED',
    uiState: 'executed',
    grantsAuthority: false,
    distinctions: {
      aiNarrativeIsNotSystemTruth: true,
      proposalIsNotApproved: true,
      approvedIsNotExecuted: true,
      executedIsNotReconciled: true,
      receiptIsNotAiSummary: true,
      retryConversationIsNotRetryMutation: true,
    },
  };
}

export function feSafeWorkbenchControlledLaneViewV1(): WorkbenchControlledLaneViewV1 {
  return {
    flowPurpose: 'PRODUCE_TO_OUTPUT',
    sources: [
      { ref: 'flowPurpose:PRODUCE_TO_OUTPUT', class: 'canonical_fact' },
      { ref: 'draft:demo', class: 'draft_configuration' },
    ],
    factsVsAssumptions: {
      facts: ['FlowPurpose PRODUCE_TO_OUTPUT', 'Draft unpublished'],
      assumptions: ['operator will review before save', 'publish remains separate'],
    },
    proposalDetails: 'AI draft suggestion: rename task task_run_transformation',
    expectedEffect:
      'tasks.task_run_transformation.name: Execute authorized transformation → Execute authorized transformation (AI draft suggestion)',
    authorityDecision: 'ALLOW',
    approvalStatus: 'APPROVED',
    executionStatus: 'EXECUTED',
    receiptId: 'receipt_exec_idem_prop_second_lane_draft_rename_v1',
    recovery: null,
    provenance: 'PROPOSAL',
    uiState: 'executed',
    grantsAuthority: false,
  };
}

export function feSafeBuilderDraftSuggestionViewV1(): BuilderDraftSuggestionViewV1 {
  return {
    suggestionSummary: 'AI draft suggestion: rename task task_run_transformation',
    semanticDiff: {
      field: 'tasks.task_run_transformation.name',
      from: 'Execute authorized transformation',
      to: 'Execute authorized transformation (AI draft suggestion)',
    },
    validationNote: 'Publish remains a separate human action; AI cannot publish',
    acceptIntoDraftAllowed: true,
    rejectAllowed: true,
    publishRemainsSeparate: true,
    uiState: 'executed',
    grantsAuthority: false,
  };
}
